import Place from './Place.vue';
export * from './types';
export default Place;



// WEBPACK FOOTER //
// ./src/components/parts/catalog/card/components/tabs/place/index.ts